import React from 'react';
import {Link,NavLink} from 'react-router-dom';

class Card extends React.Component{
	state={user:''}

	componentDidMount(){
		let user=this.props.match.params.user;
		this.setState({user:user})
	}

	render(){
		const {user}=this.state
		if (user==='Phone'){
			return(	
			<div>
				<nav className="ui raised very padded segment">
				    <span style={{fontSize:'25px'}} ><Link to="/">Asfak Ahmed</Link></span>
					<div className="ui right floated header">
					<Link to="/About"><button className="ui button">About</button></Link>
					<NavLink to="/Projects"><button className="ui button">Projects</button></NavLink>
					<NavLink to="/Contact"><button className="ui yellow button">Contact</button></NavLink>
					</div>
				</nav>
				<br/>
				<br/>
		        <div className="ui raised very padded text container segment" >
					<h3 className='ui header' style={{textAlign:'center'}}>{user} : 01521259536</h3>
				</div>
			</div>
			)
		}else{
			return(	
			<div>
				<nav className="ui raised very padded segment">
				    <span style={{fontSize:'25px'}} ><Link to="/">Asfak Ahmed</Link></span>
					<div className="ui right floated header">
					<Link to="/About"><button className="ui button">About</button></Link>
					<NavLink to="/Projects"><button className="ui button">Projects</button></NavLink>
					<NavLink to="/Contact"><button className="ui yellow button">Contact</button></NavLink>
					</div>
				</nav>
				<br/>
				<br/>
		        <div className="ui raised very padded text container segment" >
					<h3 className='ui header' style={{textAlign:'center'}}>{user} : Asfakmunna@yahoo.com</h3>
				</div>
			</div>
			)			
		}

	}
}

export default Card;